<template>
  <div class="yx-message-box" id="yxMessageBox">
    <div class="mask"></div>
    <div class="main" :class="{show}">
      <div class="message-con">
        <p class="title">{{title}}</p>
        <p>{{content}}</p>
      </div>
      <div class="message-oper">
        <button @click="cancelSubmit">取消</button>
        <button @click="okSubmit" class="orange">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        title: '',
        message: '',
        show: false,
      }
    },
    methods: {
      toggleContainer () {
        setTimeout(() => {
          this.show = !this.show;
          if (!this.show) {
            setTimeout(() => {
              this.$el.parentNode.removeChild(this.$el)
            }, 300)
          }
        }, 100)
      },
      cancelSubmit () {
        this.toggleContainer();
        this.onCancel && this.onCancel();
      },
      okSubmit () {
        this.toggleContainer();
        this.onOk && this.onOk();
      },
      clearExistElement () {
        let existEle = document.querySelector('#yxMessageBox');
        if (existEle) {
          document.body.removeChild(existEle)
        }
      }
    },
    mounted () {
      this.clearExistElement();
      this.toggleContainer();
    }
  }
</script>

<style scoped lang="scss">
  .yx-message-box{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 100;
    left:0;
    top:0;
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      top:0;
      left:0;
    }
    .main{
      width: 70%;
      background: #fff;
      border-radius: .5rem;
      position: absolute;
      margin: auto;
      left:0;
      right:0;
      top: 40%;
      transition: all .3s ease;
      transform: translateY(-50%);
      opacity: 0;
			z-index: 5;
      &.show{
        top: 45%;
        opacity: 1;
      }
      .message-con{
        padding: 2rem 1rem;
        p.title{
          font-size: 1.5rem;
          margin-bottom: .7rem;
          color: #2c3e50;
        }
        p{
          color: #999;
          font-size: 1.25rem;
          text-align: center;
        }
      }
      .message-oper{
        height: 3.5rem;
        display: flex;
        border-top: solid thin #efefef;
        overflow: hidden;
        border-bottom-left-radius: .5rem;
        border-bottom-right-radius: .5rem;
        button{
          flex: 1;
          height: 3.5rem;
          background: #fff;
          &:nth-child(2){
            border-left: solid thin #efefef;
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/yx-alert/index.vue